import { render, staticRenderFns } from "./RevenueAccrual.vue?vue&type=template&id=bd1f6b66&"
import script from "./RevenueAccrual.vue?vue&type=script&lang=js&"
export * from "./RevenueAccrual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports